import {ShellFooter as SharedShellFooter} from '@hconnect/uikit/src/lib2'
import {ShellFooterProps as SharedShellFooterProps} from '@hconnect/uikit/src/lib2/shell/footer/ShellFooter'
import React from 'react'

export type ShellFooterProps = Omit<SharedShellFooterProps, 'logo'>

export function ShellFooter({label, copyrightNote}: ShellFooterProps) {
  return <SharedShellFooter label={label} copyrightNote={copyrightNote} />
}
